export const DefaultAgTechUser: AgTechUser = {
    id: '',
    name: '',
    username: '',
    token: '',
    role: []
};

export type AgTechUser = {
    id: string,
    name: string,
    username: string,
    token: string,
    role: string[]
};

export const AgTechIdentityBaseURL = 'https://newdakotaagetchauth.azurewebsites.net';

export const AuthTokenStorageKey = 'auth_token';
export const RefreshTokenStorageKey = 'refresh_token';